export class EventManager {
	constructor() {
		this._listeners = new Map();
	}

	on(event, listener) {
		if (!this._listeners.has(event)) {
			this._listeners.set(event, []);
		}
		this._listeners.get(event).push(listener);
	}

	off(event, listener) {
		const listeners = this._listeners.get(event);
		if (!listeners) return;
		this._listeners.set(
			event,
			listeners.filter(h => h !== listener)
		);
	}

	emit(event, payload) {
		const listeners = this._listeners.get(event);
		if (!listeners) return;
		listeners.forEach(h => h(payload));
	}
}

export const eventManager = new EventManager();
